module.exports = __webpack_public_path__ + "static/media/undraw_usability_testing_2xs4.941e5d01.svg";